import request from './request';
export function getItemList(params) {
  return request.get('/api/shop/itemList', { params });
}
export function getCategoryList() {
  return request.get('/api/shop/categoryList');
}
export function buyItem(itemId, quantity = 1) {
  return request.post('/api/shop/buyItem', { item_id: itemId, quantity });
}
export function getMyItems() {
  return request.get('/api/shop/myItems');
}
export function useItem(userItemId, targetId) {
  return request.post('/api/shop/useItem', { user_item_id: userItemId, target_id: targetId });
}
